












































































import Vue from "vue"
import { Prop } from "vue-property-decorator"
import { Component, Watch } from "vue-property-decorator"
import { Maybe, Scalars } from "@/generated/graphql"
import { getToken } from "@nielsen-media/auth-api/src/auth"
import { getConfigMap } from "@/helpers/config.helper"

// TODO: move type to activeSessions store when ready
interface Filter {
  appId?: Maybe<Scalars["String"]>
  myLocation?: boolean
  product?: string[]
}

@Component
export default class ActiveSessionsFilterSheet extends Vue {
  @Prop({ default: () => ({}) })
  filter!: Filter

  sheet = false
  availableProducts = [
    { name: "Cloud", value: "Cloud" },
    { name: "S2S", value: "Audit" },
    { name: "App", value: "App" },
    { name: "Browser", value: "Browser" },
  ]

  @Watch("filter")
  handler(value: Filter): void {
    this.$emit("filter", value)
    this.$gtag.event("filter", {
      event_category: "active_session_table",
      event_label: "Filter Change",
    })
  }

  canViewDotButton(): boolean {
    // @ts-ignore
    const config = getConfigMap(this.$auth?.userConfig || [])
    return config["dotCliButton_cat_ui"]?.enabled || false
  }

  async downloadDot(os: string): Promise<void> {
    try {
      const token = await getToken()
      const apiBaseUrl = process.env.VUE_APP_EXPORT_URL_BASE || "https://cat-api-staging.nlsn-eng-ops.com"
      const apiUrl = `${apiBaseUrl}/api/v1/dotcli/download?os=${os}`
      const filename = os === "win" ? "dot-cli-installer.exe" : "dot-cli-installer.pkg"

      const response = await fetch(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      })

      if (!response.ok) {
        throw new Error(`Download failed: ${response.statusText}`)
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", filename)
      link.click()
      setTimeout(() => window.URL.revokeObjectURL(url), 10000)

      this.$gtag.event("download", {
        event_category: "active_session_table",
        event_label: `Download DOT CLI (${os})`,
      })
    } catch (error) {
      console.error("Error downloading DOT CLI:", error)
    }
  }
}
